/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BillingSubscriptionId } from "../../commons/types/BillingSubscriptionId";
import { AccountId } from "../../commons/types/AccountId";
import { BillingSubscriptionItem } from "./BillingSubscriptionItem";
export const BillingSubscription = core.serialization.object({
    id: BillingSubscriptionId,
    stripeSubscriptionId: core.serialization.string(),
    status: core.serialization.string(),
    accountId: AccountId,
    items: core.serialization.list(BillingSubscriptionItem),
});
